<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Danh mục tin tức
        </label>
        <b-form-select v-model="entry.type" :options="options"></b-form-select>
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            type: "",
        },
        options: [
          { value: null, text: 'Chọn danh mục...' },
          { value: 'Thông báo', text: 'Thông báo' },
          { value: 'Học bổng', text: 'Học bổng' },
          { value: 'Sinh viên', text: 'Sinh viên' },
          { value: 'Thời khóa biểu', text: 'Thời khóa biểu' },
          { value: 'Sự kiện', text: 'Sự kiện' },
          { value: 'Hợp tác', text: 'Hợp tác' },
        ]
    }),
    watch: {
        "entry.type": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    type: this.entry.type,
                });
            },
            deep: true,
        },
        "value.type": {
            handler: function () {
                this.entry.type = this.value.type;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>